export const ExpandIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M5 11L0.669874 6.5L9.33013 6.5L5 11Z" fill="currentColor" />
            <path d="M5 0L9.33013 4.5L0.669873 4.5L5 0Z" fill="currentColor" />
        </svg>
    );
};
